import { useOverlayScrollbars, UseOverlayScrollbarsParams } from 'overlayscrollbars-react';
import { useEffect, useRef } from 'react';

export default (params?: UseOverlayScrollbarsParams, destroy?: boolean) => {
	const rootRef = useRef<HTMLDivElement>();
	const viewportRef = useRef();

	const [initialize, instance] = useOverlayScrollbars(params);

	useEffect(() => {
		if (rootRef.current && viewportRef.current && !destroy) {
			initialize({
				target: rootRef.current,
				elements: {
					viewport: viewportRef.current
				}
			});
		}
	}, [initialize]);

	return [rootRef, viewportRef, instance()] as const;
};
